import { ErrorToast, SuccessToast } from '@services/utils/ToastUtils';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DealNoteService } from '../../../services/portfolio/DealNoteService';
import { AppState } from '../../../store/AppState';
import { DealerState } from '../../../types/DealerState';
import { IPitchStatusState } from '../../../types/PitchStatus';
import PitchStatusDropdown from '../pitch-status-dropdown/PitchStatusDropdown';

type DealPitchStatusProps = {
  dealerId: string;
  leadId: string;
  vin: string;
  status: string;
  subStatus: string;
  isNotesModalOpen: boolean;
  onPitchStatusChange?: (value: IPitchStatusState) => void;
  refreshPortfolio?: () => void;
};

const DealPitchStatus: FC<DealPitchStatusProps> = (props) => {
  const { pitchStatus } = useSelector<AppState, DealerState>((state) => state.dealer);
  const status = pitchStatus.find((value) => value.index === 100);
  const defaultPitchStatus: IPitchStatusState = {
    ...status,
    index: status?.index ?? 0,
    name: status?.name ?? '',
    value: status?.value ?? '',
    subStatuses: [],
  };
  const [isPitchStatusChanged, setIsPitchStatusChanged] = useState<boolean>(false);
  const [selectedStatus, setSelectedStatus] = useState<IPitchStatusState>(defaultPitchStatus);

  const handlePitchStatusChange = (selectedPitchStatus: IPitchStatusState) => {
    const pitchStatusSelected =
      selectedPitchStatus.subStatuses && selectedPitchStatus.subStatuses.length > 0
        ? selectedPitchStatus.subStatuses[0].value
        : selectedPitchStatus.value;
    DealNoteService.createSelectedPitchStatus(
      pitchStatusSelected,
      props.leadId,
      props.vin,
      props.dealerId,
      selectedPitchStatus,
    )
      .then((response) => {
        if (response) {
          setSelectedStatus(selectedPitchStatus);
          if (props.onPitchStatusChange) {
            props.onPitchStatusChange(selectedPitchStatus);
          }
          SuccessToast('Sales Status Updated');
          setIsPitchStatusChanged(true);
        }
      })
      .catch((err) => {
        ErrorToast('Unable to update status');
      });
  };

  useEffect(() => {
    if (isPitchStatusChanged) {
      props.refreshPortfolio && props.refreshPortfolio();
      setIsPitchStatusChanged(false);
    }
  }, [props.isNotesModalOpen]);

  useEffect(() => {
    const selectedPitchStatus = pitchStatus.find((x) => x.name === props.status);

    if (selectedPitchStatus) {
      const pitchSubStatus = selectedPitchStatus.subStatuses.find(
        (y) => y.name === props.subStatus,
      );
      setSelectedStatus({
        ...selectedPitchStatus,
        subStatuses: pitchSubStatus ? [pitchSubStatus] : [],
      });
    }
  }, [props.status, props.subStatus, pitchStatus]);

  return (
    <div className='dropdowns-wrapper'>
      <PitchStatusDropdown
        selectedStatus={selectedStatus}
        pitchStatusChange={handlePitchStatusChange}
        fromNotesModal={true}
      />
    </div>
  );
};

export default DealPitchStatus;
